import { render, staticRenderFns } from "./CorporateVideo.vue?vue&type=template&id=45d82143&scoped=true&"
import script from "./CorporateVideo.vue?vue&type=script&lang=js&"
export * from "./CorporateVideo.vue?vue&type=script&lang=js&"
import style0 from "./CorporateVideo.vue?vue&type=style&index=0&id=45d82143&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d82143",
  null
  
)

export default component.exports